import { GiftCodeDto } from "@babackapp/private-api-client/types";
import { Badge } from "@babackapp/ui/components/badge";
import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "date-fns";
import GiftCodeCell from "./gift-code-cell";
import GiftCodeDownloadButton from "./gift-code-download-button";

// TODO: useTranslation
export const columns: ColumnDef<GiftCodeDto>[] = [
  {
    accessorKey: "giftCode",
    header: "Code",
    enableSorting: false,
    cell: ({ row }) => <GiftCodeCell giftCode={row.original} />,
  },
  {
    accessorKey: "orderName",
    header: "Order",
    enableSorting: false,
    cell: ({ row }) => {
      return <span className="font-medium">{row.original.orderName}</span>;
    },
  },
  {
    id: "status",
    header: "Status",
    enableSorting: false,
    cell: ({ row }) => {
      const usedAt = row.original.usedAt;
      return usedAt && usedAt > 0 ? (
        <Badge variant="outline">Used</Badge>
      ) : null;
    },
  },
  {
    id: "usedAt",
    accessorKey: "usedAt",
    header: "Used at",
    // usedAt = -1 for unused codes; ASC sort puts all unused codes first (before epoch).
    enableSorting: true,
    cell: ({ row }) => {
      const usedAt = row.original.usedAt;
      return usedAt && usedAt > 0 ? (
        <span className="text-xs font-semibold text-muted-foreground">
          {formatDate(new Date(usedAt), "dd/MM/yyyy")}
        </span>
      ) : null;
    },
  },
  {
    id: "createdAt",
    accessorKey: "createdAt",
    header: "Created at",
    enableSorting: true,
    cell: ({ row }) => (
      <span className="text-xs font-semibold text-muted-foreground">
        {formatDate(new Date(row.original.createdAt), "dd/MM/yyyy")}
      </span>
    ),
  },
  {
    id: "download",
    header: "Download",
    enableSorting: false,
    cell: ({ row }) => (
      <GiftCodeDownloadButton id={row.original.id} visible={true} />
    ),
  },
];
